import { render } from "./Ashglyph.vue?vue&type=template&id=79a5ccd8&scoped=true"
import script from "./Ashglyph.vue?vue&type=script&lang=js"
export * from "./Ashglyph.vue?vue&type=script&lang=js"

import "./Ashglyph.vue?vue&type=style&index=0&id=79a5ccd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a5ccd8"]])

export default __exports__